module.exports = __webpack_public_path__ + "static/media/Help.f9ad1297.svg";